"use client"

import { useTheme } from "next-themes"
import { Toaster as Sonner, toast as sonnerToast, type ToasterProps } from "sonner"
import { CircleCheckIcon, InfoIcon, TriangleAlertIcon, OctagonXIcon, Loader2Icon } from "lucide-react"
import { showAlert } from "@/components/ui/alert-modal"

// Globally intercept toast.error so ANY `import { toast } from 'sonner'` routes error messages to our 350x350 centered Alert Box
if (typeof window !== "undefined") {
  const sonnerAny = sonnerToast as any;
  if (!sonnerAny.__alertIntercepted) {
    sonnerAny.__alertIntercepted = true;
    sonnerAny.__originalError = sonnerAny.error;

    sonnerAny.error = (message: any, data?: any) => {
      let title = 'Error';
      let errorMsg = message;

      if (data && typeof data === 'object') {
        if (data.description) {
          title = typeof message === 'string' ? message : 'Error';
          errorMsg = data.description;
        }
      }

      if (typeof errorMsg !== 'string' && errorMsg && typeof errorMsg === 'object') {
        errorMsg = errorMsg.message || errorMsg.error || JSON.stringify(errorMsg);
      }

      showAlert.error(errorMsg, title);
      return 'alert-modal-error';
    };
  }
}

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      icons={{
        success: (
          <CircleCheckIcon className="size-4" />
        ),
        info: (
          <InfoIcon className="size-4" />
        ),
        warning: (
          <TriangleAlertIcon className="size-4" />
        ),
        error: (
          <OctagonXIcon className="size-4" />
        ),
        loading: (
          <Loader2Icon className="size-4 animate-spin" />
        ),
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          toast: "cn-toast",
        },
      }}
      {...props}
    />
  )
}

export { Toaster, sonnerToast as toast }

